import React from 'react';
import { authRoles, PERMISSION } from 'app/auth';
import i18next from 'i18next';
import { MENU_ENUM } from 'app/main/role/constants';
import en from '../i18n/en';

i18next.addResourceBundle('en', 'patient', en);

const ImportDispenseConfig = {
  settings: {
    layout: {
      config: {},
    },
    nav: {
      title: 'Import From Dispense',
    },
  },
  auth: authRoles.user,
  key: MENU_ENUM.PATIENT,
  permission: PERMISSION.CREATE,
  routes: [
    {
      path: '/patient/import',
      component: React.lazy(() => import('./ImportDispense')),
    },
  ],
};

export default ImportDispenseConfig;
